var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex items-start"
  }, [_c('label', {
    staticClass: "switch"
  }, [_c('input', {
    attrs: {
      "disabled": _vm.disabled,
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.value
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('input', !_vm.value);
      }
    }
  }), _c('span', {
    staticClass: "slider round"
  })]), _vm.label ? _c('label', {
    staticClass: "ml-2 text-base font-light mb-1",
    class: _vm.labelClass
  }, [_vm._v(_vm._s(_vm.label)), _vm.isRequired ? _c('b', {
    staticClass: "ml-1 text-red-600 font-bold"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _vm.note ? _c('span', {
    class: _vm.noteClass
  }, [_vm._v(_vm._s(_vm.noteContent))]) : _vm._e()]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }